<template>
  <v-app>
    <v-main>
      <v-container fluid>
        <router-view />
      </v-container>
    </v-main>
    <snackbar />
    <loading />
  </v-app>
</template>

<script>
import Snackbar from '@/components/Snackbar'
import Loading from '@/components/Loading'

export default {
  name: 'EdiRequestApp',
  components: {
    Snackbar,
    Loading
  }
}
</script>

<style scoped>
</style>